










































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubRepository} from '@/model/resource/GithubRepository'
import moment from 'moment'

@Component({})
export default class CDLastActiveProjectCard extends Vue {
  @Prop({type: GithubRepository, required: true})
  repository!: GithubRepository

  get orgDotStyle() {
    const color = this.repository.githubOrganization?.colorHex
    return color ? `background-color: #${color}` : ''
  }

  get committedLabel() {
    const date = this.repository.lastCommit || this.repository.updatedAt
    if (!date) return ''
    return `Committed ${moment(date).fromNow()}`
  }

  get categoryLabel() {
    const first = (this.repository.labelsTokenized || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)[0]
    return first ? first.toUpperCase() : 'PROJECT'
  }

  get organizationName() {
    return this.repository.githubOrganization?.name || ''
  }
}
